import {Transform} from "./Transform";
import LocationController from "../controllers/LocationController";
import PhoneController from "../controllers/PhoneController";
import TransformHours from "./TransformHours";
import GetOperationSystem from "../common/GetOperationSystem";
import GetBrowser from "../common/GetBrowser";
import StorageController from "../controllers/StorageController";

class TransformShop extends Transform {

    getSplash(data = null) {
        data = this.checkAndTakeJson(data);

        if (data.splashInfo && Array.isArray(data.branches)) {
            data.splashInfo.branches = data.branches;
        }

        return {
            splashInfo: this.information(data.splashInfo),
            splashEmergency: this._toEmergencyBrake(data.splashEmergency),
            branches: this.checkAndTakeArray(data.branches)
        };
    }

    _toBranch(data = null) {
        data = this.checkAndTakeJson(data);

        return {
            branchId: this.takeNumber(data, "branchId", -1),
            title: this.takeString(data, "title", ""),
            subDomain: this.takeString(data, "subDomain", ""),
            domain: this.takeString(data, "domain", ""),
            address: this.takeString(data, "address", ""),
            deliveryTransportType: this.takeString(
                data,
                "deliveryTransportType",
                "Car"
            ),
            hours: this.checkAndTakeJson(data.hours),
            deliveryMode: this.takeNumber(data, "deliveryMode", 1),
            location: LocationController.toLocation(data.location),
            phoneNumber: PhoneController.format(
                this.takeString(data, "phoneNumber", "")
            ),
        };
    }

    _toBlockSection = (data) => {
        data = this.checkAndTakeJson(data);

        // data.buttons = [
        //     {
        //         label: "Go to about us",
        //         color: "info",
        //         action: "/about"
        //     },
        //     {
        //         label: "Go to about us",
        //         color: "info",
        //         action: "/about"
        //     },
        //     {
        //         label: "Go to about us",
        //         color: "info",
        //         action: "/about"
        //     },
        //     {
        //         label: "Go to about us",
        //         color: "info",
        //         action: "/about"
        //     },
        //     {
        //         label: "Go to about us",
        //         color: "info",
        //         action: "/about"
        //     }]

        return {
            title: this.takeString(data, "title", ""),
            imageUrl: this.takeString(data, "imageUrl", ""),
            imageLocation: this.takeNumber(data, "imageLocation", 0),
            content: this.takeString(data, "content", ""),
            background: this.takeBoolean(data, "background", false),
            backgroundColor: this.takeString(data, "backgroundColor", "#fff"),


            location: this.takeString(data, 'location', ""),//global = 1 , promotion = 2 , stamp cards = 3


            id: this.takeNumber(data, 'id', -1),
            priority: this.takeNumber(data, 'priority', -1),
            enabled: this.takeBoolean(data, 'enabled', true),


            navbarLinkTitle: this.takeString(data, 'navbarLinkTitle', ""),
            pageTitle: this.takeString(data, 'pageTitle', ""),
            urlRoute: this.takeString(data, 'urlRoute', ""),

            overridePageTitle: this.takeBoolean(data, 'overridePageTitle', false),
            visibleInNavbar: this.takeBoolean(data, 'visibleInNavbar', false),
            isRoute: this.takeBoolean(data, 'isRoute', false),
            showBlockAboveMainContent: this.takeBoolean(data, 'showBlockAboveMainContent', true),

            showNativeHeader: this.takeBoolean(data, 'showNativeHeader', true),
            showNativeFooter: this.takeBoolean(data, 'showNativeFooter', true),


        };
    };

    _toTemplate = (data) => {
        data = this.checkAndTakeJson(data);

        return {
            contactUsEnabled: this.takeBoolean(data, "contactUsEnabled", false),
            aboutUsEnabled: this.takeBoolean(data, "aboutUsEnabled", false),
            pickupDeliverySelectorSection: this.takeBoolean(
                data,
                "pickupDeliverySelectorSection",
                true
            ),
            largeBannerUrl: this.takeString(data, "largeBannerUrl", ""),
            mediumBannerUrl: this.takeString(data, "mediumBannerUrl", ""),
            smallBannerUrl: this.takeString(data, "smallBannerUrl", ""),
            mapLocationSection: this.takeBoolean(data, "mapLocationSection", true),
            infoSection: this.takeBoolean(data, "infoSection", true),
            sectionBlocks: this.checkAndTakeArray(data.sectionBlocks).map(
                this._toBlockSection
            ),
            splashPageLayout: this.takeNumber(data, "splashPageLayout", 1),

            ageVerificationPopUp: this.takeBoolean(data, "ageVerificationPopUp", false),
            ageRestriction: this.takeNumber(data, "ageRestriction", 18),
            promotionSectionVisibility: this.takeBoolean(data, "promotionSectionVisibility", false),
            defaultProductView: this.takeNumber(data, "defaultProductView", 1),
            filterSectionVisibility: this.takeBoolean(data, "filterSectionVisibility", false),
            productsPageTitle: this.takeString(data, "productsPageTitle", "Menu"),
            allergiesSectionVisibility: this.takeBoolean(data, "allergiesSectionVisibility", false),

            noProductImageAvailable: this.takeString(data, "noProductImageAvailable", ""),

        };

    };

    _toColors = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            colorBar: this.takeString(data, "colorBar", "#fafafa"),
            colorTab: this.takeString(data, "colorTab", "#000"),
            primaryLight: this.takeString(data, "primaryLight", "#ff0000"),
            primary: this.takeString(data, "primary", "#9d0000"),
            primaryDark: this.takeString(data, "primaryDark", "#560000"),
            secondaryLight: this.takeString(data, "secondaryLight", "#0027ff"),
            secondary: this.takeString(data, "secondary", "#001ba6"),
            secondaryDark: this.takeString(data, "secondaryDark", "#000d52"),
            textPrimary: this.takeString(data, "textPrimary", "#222"),
            textSecondary: this.takeString(data, "textSecondary", "#888"),
            divider: this.takeString(data, "divider", "#eee"),
            backgroundColor: this.takeString(data, "backgroundColor", "#fafafa"),
        };
    };

    _toSeo = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            facebookPixelCode: this.takeString(data, "facebookPixelCode", ""),
            googleAnalytics: this.takeBoolean(data, "googleAnalytics", false),
            googleAnalyticsCode: this.takeString(data, "googleAnalyticsCode", ""),
            priceRange: this.takeString(data, "priceRange", ""),
            servesCuisine: this.takeString(data, "servesCuisine", ""),
            summary: this.takeString(data, "summary", ""),
            title: this.takeString(data, "title", ""),
        };
    };

    _toTimeZone = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            id: this.takeNumber(data, "id", 21),
            key: this.takeString(data, "key", ""),
            name: this.takeString(data, "name", ""),
            offset: this.takeNumber(data, "offset", 0),
        };
    };

    information(data = {}) {
        data = this.checkAndTakeJson(data);

        return {
            id: this.takeNumber(data, "id", -1),
            subTitle: this.takeString(data, "subTitle", ""),
            title: this.takeString(data, "title", ""),
            rootUrl: this.takeString(data, "rootUrl", ""),
            address: this.takeString(data, "address", ""),
            cashType: this.takeNumber(data, "cashType", 1),
            deliveryCost: this.takeNumber(data, "deliveryCost", 0),
            latitude: this.takeString(data, "latitude", 0),
            longitude: this.takeString(data, "longitude", 0),
            logoUrl: this.takeString(data, "logoUrl", ""),
            faviconUrl: this.takeString(data, "faviconUrl", ""),
            email: this.takeString(data, "email", ""),
            maxCashAmount: this.takeNumber(data, "maxCashAmount", 20),
            phoneNumber: PhoneController.unformat(data.phoneNumber),
            location: LocationController.toLocation(data.location),
            currencySymbol: this.takeString(data, "currencySymbol", "$"),
            hours: TransformHours.get(data.hours),
            productShowAsList: this.takeBoolean(
                data,
                "productShowAsList",
                StorageController.restoreShowAsCard()
            ),
            pickupEnabled: this.takeBoolean(data, "pickupEnabled", false),
            availablePaymentTypes: this.checkAndTakeArray(data.availablePaymentTypes).map(i => parseInt(i + "")),
            socialNetworks: this.checkAndTakeArray(data.socialNetworks),
            poweredBy: this.takeString(data, "poweredBy", ""),
            poweredByWebsiteUrl: this.takeString(data, "poweredByWebsiteUrl", "#"),
            branches: this.checkAndTakeArray(data.branches).map(i => this._toBranch(i)),
            ownerCompany: this.takeNumber(data, "ownerCompany", 0),
            showNoPopupsByDefault: this.takeBoolean(
                data,
                "showNoPopupsByDefault",
                false
            ),
            template: this._toTemplate(data.template),
            colors: this._toColors(data.colors),
            seo: this._toSeo(data.seo),
            timeZone: this._toTimeZone(data.timeZone),
            emergencyBrake: this._toEmergencyBrake(data.emergencyBrake),
            emergencyBrakeEnabled: this.takeBoolean(data, "emergencyBrakeEnabled", false),

            deliveryMode: this.takeNumber(data, "deliveryMode", 1),
            deliveryTransportType: this.takeNumber(data, "deliveryTransportType", 1),
            deliveryTravelMaxDistance: this.takeNumber(data, "deliveryTransportType", 1000),
            deliveryTravelTime: this.takeString(data, "deliveryTravelTime", "00:00:00"),


            cashPayMaxAmount: this.takeNumber(data, "cashPayMaxAmount", 0),
            cashPayStatus: this.takeBoolean(data, "cashPayStatus", false),

            rewardsProgram: this._toRewardProgram(data.rewardsProgram),
            asSoonAsPossibleDesiredDateTimeEnabled: this.takeBoolean(data, 'asSoonAsPossibleDesiredDateTimeEnabled', true),
        };
    }

    _toEmergencyBrake = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            minDelivery: this.takeNumber(data, "minDelivery", 0),
            deliveryDelayTime: this.takeNumber(data, "deliveryDelayTime", 0),
            minPickup: this.takeNumber(data, "minPickup", 0),
            pickupDelayTime: this.takeNumber(data, "pickupDelayTime", 0),
            deliveryTemporaryUnavailable: this.takeBoolean(
                data,
                "deliveryTemporaryUnavailable",
                false
            ),
            pickupTemporaryUnavailable: this.takeBoolean(
                data,
                "pickupTemporaryUnavailable",
                false
            ),
            webshopAvailable: this.takeBoolean(data, "webshopAvailable", true),
            deliveryDelayMessage: this.takeString(data, "deliveryDelayMessage", ""),
            pickupDelayMessage: this.takeString(data, "pickupDelayMessage", ""),
            webshopAvailableMessage: this.takeString(
                data,
                "webshopAvailableMessage",
                ""
            ),
        };
    };

    options = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            emergencyBrake: this._toEmergencyBrake(data.emergencyBrake),
            cashPayMaxAmount: this.takeNumber(data, "cashPayMaxAmount", 20),
            pickupEnabled: this.takeBoolean(data, "pickupEnabled", true),
            deliveryEnabled: this.takeBoolean(data, "deliveryEnabled", true),

            tip: this._toTip(data.tip),
            zones: this.checkAndTakeArray(data.zones),
            futureOrder: this._toFutureOrder(data.futureOrder),
            localDatetime: this.takeString(data, "localDatetime", ""),
            routing: this._toRouting(data.routing),
            availablePaymentTypes: this.checkAndTakeArray(
                data.availablePaymentTypes
            ),
            cashPayStatus: this.takeNumber(data, "cashPayStatus", 1),
            minimumPrepareTime: this._toMinimumPrepareTime(
                data.minimumPrepareTime
            ),
            deliveryMode: this.takeNumber(data, "deliveryMode", 1),
            rewardsProgram: this._toRewardProgram(data.rewardsProgram),
            threeDimensionalSecurePayment: this.takeBoolean(data, "threeDimensionalSecurePayment", false)
        };
    };

    _toRewardProgram(data = null) {
        data = this.checkAndTakeJson(data);
        return {
            enabled: this.takeBoolean(data, "enabled", false),
            minimumPointsRedeemablePerOrder: this.takeNumber(
                data,
                "minimumPointsRedeemablePerOrder",
                0
            ),
            maximumPointsRedeemablePerOrder: this.takeNumber(
                data,
                "maximumPointsRedeemablePerOrder",
                0
            ),
            valuePerPoint: this.takeNumber(data, "valuePerPoint", 1),
        };
    }

    _toMinimumPrepareTime = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            pickup: this.takeNumber(data, "pickup", 0),
            delivery: this.takeNumber(data, "delivery", 0),
        };
    };

    _toFutureOrder = (data = null) => {
        data = this.checkAndTakeJson(data);
        return {
            preOrderEnabled: this.takeBoolean(data, "preOrderEnabled", true),
            minimumDate: this.takeString(data, "minimumDate", null),
            maximumDate: this.takeString(data, "maximumDate", null),
            maxDays: this.takeNumber(data, "maxDays", 3),
        };
    };

    _toTip = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            showTipOption: this.takeBoolean(data, "showTipOption", true),
            defaultTipPercentage: this.takeNumber(data, "defaultTipPercentage", 0),
            tipPercentages: this.checkAndTakeArray(
                data.tipPercentages,
                [10, 15, 20]
            ),
        };
    };

    _toRouting = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            travelMaxDistance: this.takeNumber(data, "travelMaxDistance", 0),
            transportType: this.takeNumber(data, "transportType", 1),
        };
    };

    basket(input = null) {
        const data = this.checkAndTakeJson(input);

        return {
            id: this.takeNumber(data, "id", this.takeNumber(data, "cartId", 0)),
            cartId: this.takeNumber(data, "cartId", 0),
            customerId: this.takeNumber(data, "customerId", 0),
            totalAmount: this.takeNumber(data, "totalAmount", 0),
            totalSavedAmount: this.takeNumber(data, "totalSavedAmount", 0),
            items: this.checkAndTakeArray(data.items).map(i => this._toBasketItem(i)),
            points: this.takeNumber(data, "points", 0),
            redeemPoints: this.takeNumber(data, "redeemPoints", 0),
            subTotal: this.takeNumber(data, "subTotal", 0),
            additionalItems: this.checkAndTakeArray(data.additionalItems),
            promotions: this.checkAndTakeArray(data.promotions).map(
                this._toBasketPromotion
            ),
            orderType: this.takeNumber(data, "orderType", -1),
            desiredDate: this.takeString(data, "desiredDate", ""),
            desiredTime: this.takeString(data, "desiredTime", ""),

        };
    }

    _toBasketItem = (input) => {
        const data = this.checkAndTakeJson(input);

        return {
            id: this.takeNumber(data, "id", -1),
            stampCardBonusItem: this.takeBoolean(data, "stampCardBonusItem", false),
            promotionItem: this.takeBoolean(data, "promotionItem", false),
            promotionId: this.takeNumber(data, "promotionId", -1),
            productId: this.takeNumber(data, "productId", -1),
            relatedProductId: this.takeNumber(data, "relatedProductId", null),
            relatedItemId: this.takeNumber(data, "relatedItemId", null),
            title: this.takeString(data, "title", ""),
            quantity: this.takeNumber(data, "quantity", 0),
            price: this.takeNumber(data, "price", 0),
            savedAmount: this.takeNumber(data, "savedAmount", 0),
            note: this.takeString(data, "note", ""),
            extras: this.checkAndTakeArray(data.extras).map(i => this._toExtraItem(i)),
            extrasNames: this.takeString(data, "extrasNames", ""),
            totalAmount: this.takeNumber(data, "totalAmount", 0),
            minOrderQuantity: this.takeNumber(data, "minOrderQuantity", 0),
            maxOrderQuantity: this.takeNumber(data, "maxOrderQuantity", 99),
            imageUrl: this.takeString(data, "imageUrl", ""),
            additionalText: this._toAdditionalText(
                this.takeString(data, "additionalText", "")
            ),
        };
    };

    _toAdditionalText = (data = "") => {
        if (data.length !== 0) {
            data += " ";
        }
        return data;
    };

    _toExtraItem = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            id: this.takeNumber(data, "id", -1),
            cartItemId: this.takeNumber(data, "cartItemId", 0),
            extraId: this.takeNumber(data, "extraId", -1),
            extraItemId: this.takeNumber(data, "extraItemId", -1),

            extraItemOptionId: this.takeNumber(data, "extraItemOptionId", -1),
            extraItemOptionTitle: this.takeString(data, "extraItemOptionTitle", ""),

            quantity: this.takeNumber(data, "quantity", 1),
            extraTitle: this.takeString(data, "extraTitle", ""),
            extraItemTitle: this.takeString(data, "extraItemTitle", ""),
            price: this.takeNumber(data, "price", 0),
            totalAmount: this.takeNumber(data, "totalAmount", 0),
            pizzaSide: this.takeNumber(data, "pizzaSide", 0),
            text: this.takeString(data, "text", "")
        };
    };

    _toBasketPromotion = (data = {}) => {
        data = this.checkAndTakeJson(data);
        let type = this.takeNumber(data, "type", -1);
        return {
            id: this.takeNumber(data, "id", null),
            name: this.takeString(data, "name", ""),
            type: type,
            removable: this.takeBoolean(data, "removable", false),
            options: this._toPromotionOption(data.options, type),
        };
    };

    _toPromotionOption = (data = null, type) => {
        switch (+type) {
            case 2:
                return this._toOptionType2(data);
            case 3:
                return this._toOptionType3(data);
            case 4:
                return this._toOptionType4(data);
            case 5:
                return this._toOptionType5(data);
            default:
                return null;
        }
    };

    _toOptionType2 = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            freeProductFrom: this.takeNumber(data, "freeProductFrom", 0),
            policy: this.takeNumber(data, "policy", 1),
            products: this.checkAndTakeArray(data.products).map(i => this.toTextValue(i)),
            relatedProducts: this.checkAndTakeArray(data.relatedProducts).map(i => this.toTextValue(i)),
            howOften: this.takeNumber(data, "howOften", 1),
            selectionMode: this.takeNumber(data, "selectionMode", 1),
            showDialog: this.takeBoolean(data, "showDialog", true),
            validFor: this.takeNumber(data, "validFor", 1),
            title: this.takeString(data, "title", ""),
            text: this.takeString(data, "text", ""),
            availableFor: this.takeNumber(data, "availableFor", 0),
            freeProductTypePolicy: this.takeNumber(data, "freeProductTypePolicy", 0),
        };
    };

    _toOptionType3 = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            amount: this.takeNumber(data, "amount", 0),
            amountDiscountType: this.takeNumber(data, "amountDiscountType", 1),
            discountProductFrom: this.takeNumber(data, "discountProductFrom", 0),
            discountType: this.takeNumber(data, "discountType", 1),
            percent: this.takeNumber(data, "percent", 0),
            percentDiscountType: this.takeNumber(data, "percentDiscountType", 1),
            policy: this.takeNumber(data, "policy", 1),
            showDialog: this.takeBoolean(data, "showDialog", true),
            title: this.takeString(data, "title", ""),
            text: this.takeString(data, "text", ""),
            type: this.takeNumber(data, "type", 3),
            products: this.checkAndTakeArray(data.products).map(i => this.toTextValue(i)),
            availableFor: this.takeNumber(data, "availableFor", 0),

        };
    };

    _toOptionType4 = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            products: this.checkAndTakeArray(data.products).map(i => this.toTextValue(i)),
            relatedProducts: this.checkAndTakeArray(data.relatedProducts).map(i => this.toTextValue(i)),
            howOften: this.takeNumber(data, "howOften", 1),
            selectionMode: this.takeNumber(data, "selectionMode", 1),
            showDialog: this.takeBoolean(data, "showDialog", true),
            validFor: this.takeNumber(data, "validFor", 1),
            title: this.takeString(data, "title", ""),
            text: this.takeString(data, "text", ""),
            availableFor: this.takeNumber(data, "availableFor", 0),
            pickProductPolicy: this.takeNumber(data, "pickProductPolicy", 1),
        };
    };

    _toOptionType5 = (data = null) => {
        data = this.checkAndTakeJson(data);

        return {
            products: this.checkAndTakeArray(data.products).map(i => this.toTextValue(i)),
            relatedProducts: this.checkAndTakeArray(data.relatedProducts).map(i => this.toTextValue(i)),
            howOften: this.takeNumber(data, "howOften", 1),
            selectionMode: this.takeNumber(data, "selectionMode", 1),
            showDialog: this.takeBoolean(data, "showDialog", true),
            validFor: this.takeNumber(data, "validFor", 1),
            title: this.takeString(data, "title", ""),
            text: this.takeString(data, "text", ""),
            discountType: this.takeNumber(data, "discountType", 1),
            amountDiscountType: this.takeNumber(data, "amountDiscountType", 1),
            percentDiscountType: this.takeNumber(data, "percentDiscountType", 1),
            amount: this.takeNumber(data, "amount", 1),
            percent: this.takeNumber(data, "percent", 1),
            availableFor: this.takeNumber(data, "availableFor", 0),
            pickProductPolicy: this.takeNumber(data, "pickProductPolicy", 2),

        };
    };

    categories(data = null) {
        let arr = this.checkAndTakeArray(data);//.map(this._toCategory);

        return arr.map(i => this._toCategory(i));
    }

    _toCategory(body = null) {
        let data = this.checkAndTakeJson(body);

        const isSecret = this.takeBoolean(data, "isSecret", false);
        const showPopularProducts = this.takeBoolean(data, "showPopularProducts", false);

        const sortByKey = (array, sortCondition = true) => {
            if (sortCondition) {
                const key = "rank";

                let sorted = array
                    .filter((pro) => pro[key] > 0)
                    .sort(function (a, b) {
                        let x = a[key];
                        let y = b[key];
                        return x < y ? -1 : x > y ? 1 : 0;
                    });

                return [...sorted, ...array.filter((pro) => pro.rank === 0)];
            }
            return array;
        };

        return {
            id: this.takeNumber(data, "id", -1),
            title: this.takeString(data, "title", ""),
            description: this.takeString(data, "description", ""),
            imageFullPath: this.takeString(data, "imageFullPath", ""),
            isSecret: isSecret,
            showPopularProducts: showPopularProducts,
            products: sortByKey(
                this.checkAndTakeArray(data.products).map((product) => ({
                    id: this.takeNumber(product, "id", -1),
                    name: this.takeString(product, "name", ""),
                    allergicStuffs: this.checkAndTakeArray(data.allergicStuffs),
                    imageFullPath: this.takeString(product, "imageFullPath", ""),
                    thumbnailImage: this.takeString(product, "thumbnailImage", this.takeString(product, "imageFullPath", "")),
                    description: this.takeString(product, "description", ""),
                    deliveryPrice: this.takeNumber(product, "deliveryPrice", 0),
                    pickupPrice: this.takeNumber(product, "pickupPrice", 0),
                    customizable: this.takeBoolean(product, "customizable", false),
                    defaultExtraItems: this.checkAndTakeArray(product.defaultExtraItems),
                    containsAlcohol: this.takeBoolean(
                        product,
                        "containsAlcohol",
                        false
                    ),
                    halal: this.takeBoolean(product, "halal", false),
                    organic: this.takeBoolean(product, "organic", false),
                    vegan: this.takeBoolean(product, "vegan", false),
                    vegetarian: this.takeBoolean(product, "vegetarian", false),
                    spiciness: this.takeNumber(product, "spiciness", 0),
                    rank: this.takeNumber(product, "rank", 0),
                    initialPrice: this.takeNumber(product, "initialPrice", 0),
                })),
                showPopularProducts
            ),
        };
    }

    checkout(checkout = null) {
        const data = this.checkAndTakeJson(checkout);

        return {
            ...this._toUserInfo(data),
            ...this._toAddress(data),
            ...this._toPayment(data),
            ...this._toConfirm(data),
            ...this._toDesired(data),
            clientSecret: this.takeString(data, "clientSecret", ""),
            paymentIntent: this._paymentIntent(data.paymentIntent),
            paymentIntentId: this.takeString(data, "paymentIntentId", ""),
            paymentMethods: this.checkAndTakeArray(data.paymentMethods).map(i => this._toCheckoutPaymentMethod(i)),
            deliveryInstructionsRemarks: this.takeString(data, "deliveryInstructionsRemarks", ""),
            deliverableAction: this.takeNumber(data, "deliverableAction", 1),
        };
    }

    _toCheckoutPaymentMethod(item = null) {
        const data = this.checkAndTakeJson(item);
        return {
            enabled: this.takeBoolean(data, "enabled", false),
            message: this.takeString(data, "message", ""),
            type: this.takeNumber(data, "type", 0)
        }
    }

    _paymentIntent(_payIntent = null) {
        if (!_payIntent) return null;

        const data = this.checkAndTakeJson(_payIntent);

        const total = this.checkAndTakeJson(data.total);

        return {
            country: this.takeString(data, "country", "CA"),
            currency: this.takeString(data, "currency", "usd"),
            total: {
                label: this.takeString(total, "label", ""),
                amount: this.takeString(total, "amount", ""),
            },
            requestPayerName: this.takeBoolean(data, "requestPayerName", true),
            requestPayerEmail: this.takeBoolean(data, "requestPayerEmail", true),
        }
    }

    _toDesired(desired = null) {
        let data = this.checkAndTakeJson(desired);
        return {
            desiredDate: this.takeString(data, "desiredDate", "0000-00-00"),
            desiredTime: this.takeString(data, "desiredTime", "00:00:00"),
        };
    }

    _toUserInfo(data = null, forServer = false) {
        data = this.checkAndTakeJson(data);

        let packet = {};
        packet = {
            isCompany: this.takeBoolean(data, "isCompany", false),
            companyTitle: this.takeString(data, "companyTitle", ""),
            gender: this.takeNumber(data, "gender", 2),
            firstname: this.takeString(data, "firstname", ""),
            lastname: this.takeString(data, "lastname", ""),
            email: this.takeString(data, "email", ""),
            password: this.takeString(data, "password", ""),
            phone: PhoneController.format(this.takeString(data, "phone", "")),
            reference: this.takeString(data, "reference", ""),
            customerToken: this.takeString(data, "customerToken", ""),
        }

        if (!forServer) {
            packet.emailVerification = this.takeBoolean(data, "emailVerification", false);
            packet.phoneVerification = this.takeBoolean(data, "phoneVerification", false);
            packet.phoneVerificationCode = this.takeString(data, "phoneVerificationCode", "");
            packet.emailVerificationCode = this.takeString(data, "emailVerificationCode", "");
        }


        return packet;
    }

    removeCots(value = null) {
        if (!value) return value;
        return value.replaceAll('"', "").replaceAll("'", "");
    }

    orderConfigAppendToCheckout(form) {
        let data = this.checkAndTakeJson(form);
        return {
            ...this._toAddress(data),
            tipCustomValue: this.takeNumber(data, "tipCustomValue", 0),
            tipValue: this.takeNumber(data, "tipValue", 0),
        }
    }

    _toAddress(data = null) {
        data = this.checkAndTakeJson(data);

        return {
            date: this.removeCots(this.takeString(data, "date", new Date().toLocaleDateString("en-CA", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            }))),
            time: this.takeString(data, "time", "00:00"),
            asSoonAsPossible: this.takeBoolean(data, "asSoonAsPossible", true),
            orderType: this.takeNumber(data, "orderType", -1),
            customAddress: this.takeBoolean(data, "customAddress", true),
            addressId: this.takeNumber(data, "addressId", -1),
            address: this.takeString(data, "address", ""),
            apartment: this.takeString(data, "apartment", ""),
            buzzer: this.takeString(data, "buzzer", ""),
            city: this.takeString(data, "city", ""),
            houseNo: this.takeString(data, "houseNo", ""),
            postalCode: this.takeString(data, "postalCode", ""),
            title: this.takeString(data, "title", ""),
            country: this.takeString(data, "country", ""),
            countryCode: this.takeString(data, "countryCode", ""),
            province: this.takeString(data, "province", ""),
            provinceCode: this.takeString(data, "provinceCode", ""),
            street: this.takeString(data, "street", ""),
            location: LocationController.toLocation(data.location === undefined ? data : data.location),
            distance: this.takeInteger(data, "distance", 0),
            duration: this.takeInteger(data, "duration", 0),
            streetNumber: this.takeString(data, "streetNumber", ""),
            certainAddress: this.takeBoolean(data, "certainAddress", false),
        };
    }

    _addressDetail(checkout) {

        let data = this.checkAndTakeJson(checkout);

        return {
            address: this.takeString(data, "address", ""),
            streetAddress: `${this.takeString(data, "streetNumber", "")} ${this.takeString(data, "street", "")}`.trim(),
            city: this.takeString(data, "city", ""),
            state: this.takeString(data, "provinceCode", ""),
            postalCode: this.takeString(data, "postalCode", ""),
            country: this.takeString(data, "countryCode", ""),
        }

    }

    _toPayment(data = null) {
        data = this.checkAndTakeJson(data);
        return {
            tipCustomValue: this.takeNumber(data, "tipCustomValue", 0),
            tipValue: this.takeNumber(data, "tipValue", 0),
            payWithCashAmount: this.takeNumber(data, "payWithCashAmount", 0),
            number: this.takeString(data, "number", ""),
            year: this.takeString(data, "year", ""),
            month: this.takeString(data, "month", ""),
            cVC: this.takeString(data, "cVC", ""),
            tokenId: this.takeString(data, "tokenId", ""),
            paymentType: this.takeNumber(data, "paymentType", 1),
            addressZip: this.takeString(data, "addressZip", ""),
            redeemPoints: this.takeNumber(data, "redeemPoints", 0),
            giftCardsCode: this.takeString(data, "giftCardsCode", ""),
        };
    }

    _toPaymentForCheckoutApi(data = null) {
        data = this.checkAndTakeJson(data);
        let paymentType = this.takeNumber(data, "paymentType", 1);
        let payWithCashAmount = this.takeNumber(data, "payWithCashAmount", 0);
        return {
            payWithCashAmount: paymentType === 2 ? payWithCashAmount : 0,
            card:
                paymentType === 1
                    ? {
                        tokenId: this.takeString(data, "tokenId", ""),
                        number: this.takeString(data, "number", "").replaceAll(
                            " ",
                            ""
                        ),
                        cVC: this.takeString(data, "cVC", ""),
                        month: this.takeString(data, "month", ""),
                        year: this.takeString(data, "year", ""),
                        postalCode: this.takeString(data, "addressZip", ""),
                    }
                    : null,
            tipCustomValue: this.takeNumber(data, "tipCustomValue", 0),
            tipValue: this.takeNumber(data, "tipValue", 0),
            paymentType: paymentType,
            redeemPoints: this.takeNumber(data, "redeemPoints", 0),
            giftCardsCode: this.takeString(data, "giftCardsCode", ""),
            paymentIntentId: this.takeString(data, "paymentIntentId", ""),
            chargeId: this.takeString(data, "chargeId", ""),

        };
    }

    _toConfirm(data = null) {
        data = this.checkAndTakeJson(data);
        return {
            saveAddress: this.takeBoolean(data, "saveAddress", false),
            wantToBeNotified: this.takeBoolean(data, "wantToBeNotified", false),
            remark: this.takeString(data, "remark", ""),
            oS: GetOperationSystem(),
            browser: GetBrowser(),
        };
    }

    _createDateForCheckoutApi(dateObject = new Date()) {
        if (typeof dateObject !== "object") {
            if (typeof dateObject === "string")
                return this.removeCots(dateObject);
            return dateObject;
        }

        try {
            return (
                dateObject.getFullYear() +
                "-" +
                (dateObject.getMonth() + 1) +
                "-" +
                dateObject.getDate() +
                "T00:00:00.000Z"
            );
        } catch (e) {
            return dateObject;
        }
    }

    checkoutForApi(data) {
        data = this.checkAndTakeJson(data);

        let packet = {
            ...this._toUserInfo(data, true),
            ...this._toAddress(data),
            ...this._toPaymentForCheckoutApi(data),
            ...this._toConfirm(data),
            addressDetail: this._addressDetail(data),
            deliveryInstructionsRemarks: this.takeString(data, "deliveryInstructionsRemarks", ""),
            deliverableAction: this.takeNumber(data, "deliverableAction", 1),
        };

        packet.phone = PhoneController.unformat(packet.phone);

        if (packet.asSoonAsPossible) {
            packet.date = null;
            packet.time = null;
        }

        if (packet.date !== null) {
            packet.date = this._createDateForCheckoutApi(packet.date);
        }

        packet.distance = parseInt(packet.distance + "");
        packet.duration = parseInt(packet.duration + "");

        packet.location.longitude = +(packet.location.longitude.toFixed(6) + "");
        packet.location.latitude = +(packet.location.latitude.toFixed(6) + "");

        packet.street = `${packet.streetNumber} ${packet.street}`;

        return packet;
    }

    toProduct(productData = null) {
        let product = this.checkAndTakeJson(productData);
        return {
            id: this.takeNumber(product, "id", -1),
            productId: this.takeNumber(product, "productId", -1),
            available: this.takeBoolean(product, "available", false),
            notAvailableToDate: this.takeString(product, "notAvailableToDate", null),
            name: this.takeString(product, "name", ""),
            posName: this.takeString(product, "posName", ""),
            kitchenReceiptName: this.takeString(product, "kitchenReceiptName", ""),
            description: this.takeString(product, "description", ""),
            extrasDescription: this.takeString(product, "extrasDescription", ""),
            minOrderQuantity: this.takeNumber(product, "minOrderQuantity", 1),
            maxOrderQuantity: this.takeNumber(product, "maxOrderQuantity", 3),
            onlyOnWeekDays: this.takeNumber(product, "onlyOnWeekDays", 127),
            availableInShop: this.takeBoolean(product, "availableInShop", false),
            availableInPOS: this.takeBoolean(product, "availableInPOS", false),
            deliveryPrice: this.takeNumber(product, "deliveryPrice", 0),
            pickupPrice: this.takeNumber(product, "pickupPrice", 0),
            calories: this.takeNumber(product, "calories", 0),
            availableForOrderingType: this.takeNumber(
                product,
                "availableForOrderingType",
                0
            ),
            color: this.takeString(product, "color", "#000000"),
            multiple: this.takeBoolean(product, "multiple", false),
            vegetarian: this.takeBoolean(product, "vegetarian", false),
            vegan: this.takeBoolean(product, "vegan", false),
            organic: this.takeBoolean(product, "organic", false),
            halal: this.takeBoolean(product, "halal", false),
            containsAlcohol: this.takeBoolean(product, "containsAlcohol", false),
            showCategoryExtras: this.takeBoolean(product, "showCategoryExtras", false),
            showExtrasCategory: this.takeNumber(product, "showExtrasCategory", 0),
            deleted: this.takeBoolean(product, "deleted", false),
            inMultipleCategories: this.takeBoolean(
                product,
                "inMultipleCategories",
                false
            ),
            imageFullPath: this.takeString(
                product,
                "imageFullPath",
                ""
            ),
            eanBarcode: this.takeString(product, "eanBarcode", null),
            imageBase64: this.takeString(product, "imageBase64", null),
            image: this.takeString(product, "image", null),
            preperationTime: this.takeString(product, "preperationTime", "00:15:00"),
            showFromDate: this.takeString(product, "showFromDate", null),
            showFromTime: this.takeString(product, "showFromTime", null),
            showToDate: this.takeString(product, "showToDate", null),
            showToTime: this.takeString(product, "showToTime", null),
            spiciness: this.takeNumber(product, "spiciness", 0),
            mainCategoryId: this.takeNumber(product, "mainCategoryId", 0),
            allergicStuffsId: this.checkAndTakeArray(product.allergicStuffsId),
            allergicStuffs: this.checkAndTakeArray(product.allergicStuffs),
            categories: this.checkAndTakeArray(product.categories),
            extras: this.checkAndTakeArray(product.extras).map((i) =>
                this.toExtraForProduct(i)
            ),

            chosenExtraItemsMode: this.takeNumber(product, "chosenExtraItemsMode", 1),
            customizable: this.takeBoolean(product, "customizable", false),
            displayOnKitchenDisplay: this.takeBoolean(product, "displayOnKitchenDisplay", false),


            diningPrice: this.takeNumber(product, "diningPrice", 0),
            availableIn: this.takeNumber(product, "availableIn", 0),
            points: this.takeNumber(product, "points", 0),

            defaultExtraItems: this.checkAndTakeArray(product.defaultExtraItems).map(i => this._toProductDefaultSelectedExtra(i)),

        };
    }

    _toProductDefaultSelectedExtraItem = (item = null) => {
        let data = this.checkAndTakeJson(item);
        return {
            extraItemId: this.takeNumber(data, "extraItemId", -1),
            side: this.takeNumber(data, "side", 0),
            quantity: this.takeNumber(data, "quantity", 1),
            priority: this.takeNumber(data, "priority", 0),
            price: this.takeNumber(data, "price", 0),
        }
    }

    _toProductDefaultSelectedExtra(defaultSelectedExtra = null) {
        let data = this.checkAndTakeJson(defaultSelectedExtra);


        return {
            extraId: this.takeNumber(data, "extraId", -1),
            items: this.checkAndTakeArray(data.items).map(i => this._toProductDefaultSelectedExtraItem(i))
        }
    }

    _toExtraContent(extra = null) {
        let data = this.checkAndTakeJson(extra);
        return {
            id: this.takeNumber(data, "id", -1),
            name: this.takeString(data, "name", ""),
            title: this.takeString(data, "title", ""),
            maxAllowedItems: this.takeNumber(data, "maxAllowedItems", 1),
            required: this.takeBoolean(data, "required", false),
            available: this.takeBoolean(data, "available", false),
            productsCount: this.takeNumber(data, "productsCount", 1),
            categoriesCount: this.takeNumber(data, "categoriesCount", 0),
            items: this.checkAndTakeArray(data.items).map((i) =>
                this._toExtraContentItem(i)
            ),
            products: this.checkAndTakeArray(data.products),

            increasingOtherExtraItemsPrice: this.takeBoolean(
                data,
                "increasingOtherExtraItemsPrice",
                false
            ),
            choosablePizzaToppingsSides: this.takeBoolean(
                data,
                "choosablePizzaToppingsSides",
                false
            ),
            numberOfFreeItems: this.takeNumber(data, "numberOfFreeItems", 0),
        };
    }

    _toExtraContentItem(item = null) {
        let data = this.checkAndTakeJson(item);
        return {
            id: this.takeNumber(data, "id", -1),
            title: this.takeString(data, "title", ""),
            receiptTitle: this.takeString(data, "receiptTitle", ""),
            price: this.takeNumber(data, "price", 0),
            color: this.takeString(data, "color", "#000"),
            available: this.takeBoolean(data, "available", false),
            extraId: this.takeNumber(data, "extraId", -1),
            priority: this.takeNumber(data, "priority", -1),
            min: this.takeNumber(data, "min", 1),
            max: this.takeNumber(data, "max", 1),
            calories: this.takeNumber(data, "calories", 0),
            scale: this.takeNumber(data, "scale", 1),
            increasingPriceType: this.takeNumber(data, "increasingPriceType", 0),
            increasingValue: this.takeNumber(data, "increasingValue", 0),
            options: this.checkAndTakeArray(data.options).map(i => this._toExtraContentItemOption(i))
        };
    }

    _toExtraContentItemOption(item = null) {
        let data = this.checkAndTakeJson(item);
        return {
            id: this.takeNumber(data, "id", -1),
            title: this.takeString(data, "title", ""),
            price: this.takeNumber(data, "price", 0),
        }
    }

    toExtraForProduct(extra = null) {
        let data = this.checkAndTakeJson(extra);

        return {
            productId: this.takeNumber(data, "productId", -1),
            id: this.takeNumber(data, "id", -1),
            title: this.takeString(data, "title", ""),
            extraId: this.takeNumber(data, "extraId", -1),
            extra: this._toExtraContent(data.extra),
            availableType: this.takeNumber(data, "availableType", 1),
            showType: this.takeNumber(data, "showType", -1),
            availableTypeText: this.takeString(
                data,
                "availableTypeText",
                "Shop/App and POS"
            ),
            showTypeText: this.takeString(data, "availableTypeText", "Always"),
            secondExtraId: this.takeNumber(data, "secondExtraId", null),
            secondExtraItemId: this.takeNumber(data, "secondExtraItemId", null),
            priority: this.takeNumber(data, "priority", -1),
        };
    }

    toSelectedExtra(data, newExtraItemId = null) {
        const quantitySum = (array = []) => {
            let s = 0;
            array.forEach((item) => {
                s += ((item["quantity"] / ((item["pizzaSide"] === 1 || item["pizzaSide"] === 2) ? 2 : 1)) * item["scale"])
            });
            return s;
        };
        const convert = (item) => {
            // console.log("item for convert : ", item);

            /*pizzaSide types ==> None:0 , &#9680; Left : 1  , &#9681; Right : 2 , &#11044; Whole : 3 */
            return {
                id: this.takeNumber(item, "id", -1),
                extraItemOptionId: this.takeNumber(item, "extraItemOptionId", -1),
                extraItemOptionTitle: this.takeString(item, "extraItemOptionTitle", ""),
                price: this.takeNumber(item, "price", 0),
                quantity: this.takeNumber(item, "quantity", 1),
                priority: this.takeNumber(item, "priority", -1),

                pizzaSide: this.takeNumber(item, "pizzaSide", 0),
                scale: this.takeNumber(item, "scale", 1),
                increasingPriceType: this.takeNumber(item, "increasingPriceType", 0),
                increasingValue: this.takeNumber(item, "increasingValue", 0),

                title: this.takeString(item, "title", ""),
                calories: this.takeNumber(item, "calories", 0)
            };
        };
        const createSubtitle = (arr = []) => {
            if (arr.length === 1) {
                let {title, quantity, scale, pizzaSide} = arr[0];
                return (quantity >= 1 ? parseInt(((quantity / ((pizzaSide === 1 || pizzaSide === 2) ? 2 : 1)) * scale) + "") + "x " : "") + title;
            } else if (arr.length > 1)
                return parseInt(quantitySum(arr) + "") + "x Item selected";

            return "";

        };

        let extra = this.checkAndTakeJson(data);

        if (newExtraItemId === null) newExtraItemId = extra.extraItemId;

        newExtraItemId = this.checkAndTakeArray(newExtraItemId).map((i) => convert(i));

        return {
            priority: this.takeNumber(extra, "priority", -1),
            index: this.takeNumber(extra, "index", 0),
            extraId: this.takeNumber(extra, "extraId", -1),
            extraItemId: newExtraItemId,
            secondExtraId: this.takeNumber(extra, "secondExtraId", null),
            secondExtraItemId: this.takeNumber(extra, "secondExtraItemId", null),

            // extraItemOptionId: this.takeNumber(extra, "extraItemOptionId", -1),
            // extraItemOptionTitle: this.takeString(extra, "extraItemOptionTitle", ""),

            quantity: this.takeNumber(extra, "quantity", 1),
            subtitle: createSubtitle(newExtraItemId),
            increasingOtherExtraItemsPrice: this.takeBoolean(
                extra,
                "increasingOtherExtraItemsPrice",
                false
            ),
            choosablePizzaToppingsSides: this.takeBoolean(
                extra,
                "choosablePizzaToppingsSides",
                false
            ),
            numberOfFreeItems: this.takeNumber(extra, "numberOfFreeItems", 0),

        };
    }

    toStampCard(data = null) {
        let stamp = this.checkAndTakeJson(data);
        return {
            id: this.takeNumber(stamp, "id", 0),
            period: this.takeString(stamp, "period", ""),
            title: this.takeString(stamp, "title", ""),
            text: this.takeString(stamp, "text", ""),
            enabled: this.takeBoolean(stamp, "enabled", false),
            image: this.takeString(stamp, "image", ""),
            since: this.takeString(stamp, "since", ""),
            until: this.takeString(stamp, "until", ""),
            numberOfTimes: this.takeNumber(stamp, "numberOfTimes", 0),

            description: this.takeString(stamp, "description", ""),
            discountAmount: this.takeNumber(stamp, "discountAmount", 0),
            discountPercentage: this.takeNumber(stamp, "discountPercentage", 0),
            discountType: this.takeNumber(stamp, "discountType", 1),
            maximumDiscountAmount: this.takeNumber(
                stamp,
                "maximumDiscountAmount",
                0
            ),
            minimumOrderAmount: this.takeNumber(stamp, "minimumOrderAmount", 0),
            rewardProducts: this.checkAndTakeArray(stamp.rewardProducts),
            targetedProducts: this.checkAndTakeArray(stamp.targetedProducts),
            rewardType: this.takeNumber(stamp, "rewardType", 1),
            usageType: this.takeNumber(stamp, "usageType", 1),
        };
    }

    toMyStampCard(data = null) {
        let stamp = this.checkAndTakeJson(data);
        return {
            id: this.takeNumber(stamp, "id", 0),
            stampCardId: this.takeNumber(stamp, "stampCardId", 0),
            punchs: this.takeNumber(stamp, "punchs", 0),
            status: this.takeNumber(stamp, "status", 0),
            period: this.takeString(stamp, "period", ""),
            statusTitle: this.takeString(stamp, "statusTitle", ""),
            rewardReceivedDateTime: this.takeString(
                stamp,
                "rewardReceivedDateTime",
                ""
            ),
            title: this.takeString(stamp, "title", ""),
            text: this.takeString(stamp, "text", ""),
            enabled: this.takeBoolean(stamp, "enabled", false),
            image: this.takeString(stamp, "image", ""),
            since: this.takeString(stamp, "since", ""),
            until: this.takeString(stamp, "until", ""),
            numberOfTimes: this.takeNumber(stamp, "numberOfTimes", 0),

            description: this.takeString(stamp, "description", ""),
            discountAmount: this.takeNumber(stamp, "discountAmount", 0),
            discountPercentage: this.takeNumber(stamp, "discountPercentage", 0),
            discountType: this.takeNumber(stamp, "discountType", 1),
            maximumDiscountAmount: this.takeNumber(
                stamp,
                "maximumDiscountAmount",
                0
            ),
            minimumOrderAmount: this.takeNumber(stamp, "minimumOrderAmount", 0),
            rewardProducts: this.checkAndTakeArray(stamp.rewardProducts),
            targetedProducts: this.checkAndTakeArray(stamp.targetedProducts),
            rewardType: this.takeNumber(stamp, "rewardType", 1),
            usageType: this.takeNumber(stamp, "usageType", 1),
        };
    }

    toConfirmDataStampCard(data = null) {
        data = this.checkAndTakeJson(data);
        return {

            id: this.takeNumber(data, "id", 0),
            period: this.takeString(data, "period", ""),
            title: this.takeString(data, "title", ""),
            text: this.takeString(data, "text", ""),
            enabled: this.takeBoolean(data, "enabled", false),
            image: this.takeString(data, "image", ""),
            since: this.takeString(data, "since", ""),
            until: this.takeString(data, "until", ""),
            numberOfTimes: this.takeNumber(data, "numberOfTimes", 0),
        }
    }

    toConfirmData(data = null) {
        data = this.checkAndTakeJson(data);

        return {
            orderId: this.takeNumber(data, "orderId", 0),
            fullName: this.takeString(data, "fullName", ""),
            orderCode: this.takeNumber(data, "orderCode", 0),
            email: this.takeString(data, "email", ""),
            orderType: this.takeNumber(data, "orderType", 0),
            orderTypeTitle: this.takeString(data, "orderTypeTitle", ""),
            orderDatetime: this.takeString(data, "orderDatetime", ""),
            showChooseStampCardModal: this.takeBoolean(data, "showChooseStampCardModal", false),
            reachesStampCards: this.checkAndTakeArray(data.reachesStampCards).map(i => this.toConfirmDataStampCard(i))
        }
    }

    toProductSuggestions(data = null) {
        data = this.checkAndTakeArray(data);
        // console.log("before format : ", data);
        return data.map(i => ({
            suggestedProducts: this.checkAndTakeArray(i.suggestedProducts),
            targetedProducts: this.checkAndTakeArray(i.targetedProducts),
            suggestedProductsNames: this.checkAndTakeArray(i.suggestedProductsNames).map(j => ({
                ...this.toTextValue(j),
                image: j.image
            })),
        }));
    }

    footer(input = null) {

        const data = this.information(input);

        const defaults = {
            logo: data.logoUrl,
            title: data.title,
            summary: data.subTitle,
            phone: data.phoneNumber,
            email: data.email,
            socialNetworks: data.socialNetworks,


            poweredByLogo: "https://lirp.cdn-website.com/a10a750d/dms3rep/multi/opt/Logo_C-1920w.png",
            poweredBy: "Meemup.com",
            poweredByWebsiteUrl: "https://meemup.com",


        }

        return {

            logo: this.takeString(data, "logo", defaults.logo),
            title: this.takeString(data, 'title', defaults.title),
            summary: this.takeString(data, 'summary', defaults.summary),
            phone: this.takeString(data, 'phone', defaults.phone),
            email: this.takeString(data, 'email', defaults.email),

            socialNetworks: Array.isArray(data.socialNetworks) ? this.checkAndTakeArray(data.socialNetworks) : defaults.socialNetworks,

            poweredBy: this.takeString(data, 'poweredBy', defaults.poweredBy),
            poweredByLogo: this.takeString(data, 'poweredByLogo', defaults.poweredByLogo),
            poweredByWebsiteUrl: this.takeString(data, 'poweredByWebsiteUrl', defaults.poweredByWebsiteUrl),

        }


    }

}

export default new TransformShop();
